'use client'

import { cx } from '@/app/lib/utils'
import styles from './PureButton.module.scss'
import type { PureButtonProps } from './PureButton.types'

/**
 * PureButton — primitivo de botón sin fondo ni borde.
 * Resetea los estilos nativos del `<button>` y conserva el focus ring del DS.
 * Tamaños (altura del hit area): m=28px · s=24px · xs=20px.
 */
export function PureButton({
  label,
  icon,
  size = 'm',
  type = 'button',
  disabled = false,
  onClick,
  ariaLabel,
  ariaPressed,
  className,
}: PureButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.btn, styles[`btn--${size}`], className)}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
    >
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {label && <span className={styles.label}>{label}</span>}
    </button>
  )
}
